<button
  matIconButton
  aria-label="cart button"
  (click)="toggle()"
  [matBadge]="quantity"
>
  <mat-icon fontSet="material-symbols-outlined">shopping_bag</mat-icon>
</button>
